import script from "./FamilyMemberModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FamilyMemberModal.vue?vue&type=script&setup=true&lang=js"

import "./FamilyMemberModal.vue?vue&type=style&index=0&id=14afefa6&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14afefa6"]])

export default __exports__